/*
 * AccountPage Messages
 *
 * This contains all the text for the AccountPage container.
 */

import { defineMessages } from 'react-intl';

export const scope = 'app.containers.AccountPage';

export default defineMessages({
  title: {
    id: `${scope}.title`,
    defaultMessage: 'Manage Account - PARAMETA Solutions Trading Analytics',
  },
  metaDesc: {
    id: `${scope}.metaDesc`,
    defaultMessage: 'Manage your PARAMETA Solutions user account.',
  },
  header: {
    id: `${scope}.header`,
    defaultMessage: 'Your Account',
  },
  usernameField: {
    id: `${scope}.username`,
    defaultMessage: 'Username ',
  },
  nameField: {
    id: `${scope}.name`,
    defaultMessage: 'Name ',
  },
  oktaManagementLink: {
    id: `${scope}.oktaManagementLink`,
    defaultMessage: 'https://parameta-accounts.okta.com/',
  },
  companyField: {
    id: `${scope}.company`,
    defaultMessage: 'Company ',
  },
  changeInstructions: {
    id: `${scope}.changeInstructions`,
    defaultMessage: 'To change your details, please contact {supportLink}.',
  },
  clientServicesName: {
    id: `${scope}.clientServicesName`,
    defaultMessage: 'PARAMETA Support',
  },
  resetPasswordSectionHeader: {
    id: `${scope}.resetPasswordSectionHeader`,
    defaultMessage: 'Password Management',
  },
  passwordChangeInstructions: {
    id: `${scope}.passwordChangeInstructions`,
    defaultMessage: '{changePasswordLink}',
  },
  passwordLinkText: {
    id: `${scope}.passwordLinkText`,
    defaultMessage: 'Reset your password',
  },
  contactEmail: {
    id: `${scope}.contactEmail`,
    defaultMessage:
      'ParametaSupport@tpicap.com?Subject=Update%20My%20Account%20Details',
  },
});
